import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { ClubServicesService } from '../../services/club-services.service';

@Component({
  selector: 'app-order-success-dialogue',
  templateUrl: './order-success-dialogue.component.html',
  styleUrls: ['./order-success-dialogue.component.scss']
})
export class OrderSuccessDialogueComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private csObj: CommonService,
    private toast: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogRef: MatDialog,
    private auth: AuthService,
    private  spinner: SpinnerVisibilityService,
    private clubService: ClubServicesService
  ) { }

  orderId:any;
  currentUser:any;
  defaultImage = '../../../../assets/icons/Loading_icon.gif';

  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);
  }

  // Delete teams functionality
  DeletBtnClick() {
    try {
      let id = this.data.userType.id;
      this.csObj.deleteAPI(id).subscribe((res: any) => {
        console.log(1);
        let currentURL = this.router.url;
        this.toast.success("Team Deleted successfully");
        this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentURL]);
        });

      },
        (err: any) => {
          this.toast.error(err.message);
        })
    }
    catch (e) { }
  }


   // logout  functionality
   logoutClick() {
    let u1 = this.currentUser?.userDetails?.userType;
    let u2 = this.currentUser?.userType;
    if(u1==3 || u2==3){
      this.router.navigate(['/team_dash']);
      // this.router.navigate(['/manageOrders']);
    }else{
      let orderId:any;
      this.route.queryParams.subscribe((params: any) => {
        orderId = params['requestId'];
      })
      if(!orderId){
        this.router.navigate(['/organization_dash']);
        // this.router.navigate(['/manageOrders']);
      }else{
        this.router.navigate(['/paymentReq/orderdetails'], {queryParams:{id:orderId}});
      }
    }
  }

  replaceCartItems(){
    this.data.userType.cartId;
    console.log(this.data.userType.req,"req");

    let user: any = localStorage.getItem('currentUser');
    user = JSON.parse(user);
    if (user?.userDetails?.userType != 2 || user?.userDetails?.userType!=2) {
      this.csObj.deletePlayerCart().subscribe((res:any)=>{
        if(res.status == 200){
          let req = this.data.userType.req;
          this.csObj.addtoCartPlayers(req).subscribe((res: any) => {
            if (res.status == 200) {
              (<HTMLInputElement>document.getElementById('addToCard'+this.data.userType.cartId)).innerHTML = 'View Cart';
              (<HTMLInputElement>document.getElementById('addToCard'+this.data.userType.cartId)).classList.add('viewCart');
            }
          });
        }
      })
    } else {
      this.csObj.deleteClubCart().subscribe((res:any)=>{
        if(res.status == 200){
          this.csObj.addtoCart(this.data.userType.req).subscribe((res: any) => {
            if (res.status == 200) {
              (<HTMLInputElement>document.getElementById('addToCard')).innerHTML = 'View Cart';
              (<HTMLInputElement>document.getElementById('addToCard')).classList.add('viewCart');
            }
          })
        }})
    }
  }

  replaceProducts(){
      this.csObj.removeProduct(this.data.userType.from);
  }

  replaceProductsCancel(){
    this.csObj.removeProduct(this.data.userType.previousTab+'k')
  }

  navigateToTeamDash(){
    this.router.navigateByUrl('/team_dash');
  }

  onClickClose(){
    if(this.data.userType.access=='item'){
      return
    }
    if(this.data.userType.access=='replaceCart'){
      return
    }
    if (this.currentUser?.userDetails?.userType == 3 ||   this.currentUser.userType==3) {
      console.log("navigating");
      this.navigateToTeamDash();
    }else{
      let orderId:any;
      this.route.queryParams.subscribe((params: any) => {
        orderId = params['requestId'];
      })
      if(!orderId){
        this.router.navigate(['/organization_dash']);
        // this.router.navigate(['/manageOrders']);
      }else{
        this.router.navigate(['/paymentReq/orderdetails'], {queryParams:{id:orderId}});
      }
    }

  }

}
